import React, { useEffect, useState } from "react";
import UsersStyle from "./style";
import {
  Button,
  Checkbox,
  Divider,
  Form,
  Image,
  Input,
  Row,
  Select,
  Upload,
  message,
} from "antd";
import { SearchOutlined, PlusOutlined, LeftOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import PostUpdateData from "../../../hooks/postUpdate";

const EditUser = () => {
  const path = useLocation();
  const navigate = useNavigate();
  const { TextArea } = Input;
  const editUserData = useSelector(
    (state) => state.systemTracking.editUserData
  );
  const userInfo = useSelector((state) => state.authTracking.userInfo);
  const [saving, setSaving] = useState(false);
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);

  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      firstName: editUserData?.firstName,
      lastName: editUserData?.lastName,
      email: editUserData?.email,
      bio: editUserData?.bio,
      userName: editUserData?.userName,
      timezone: editUserData?.timezone,
    });
  }, [editUserData, form]);

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const onFinish = async (values) => {
    if (!editUserData?.people_id) {
      message.error("No user selected to update");
      return;
    }

    setSaving(true);
    try {
      await PostUpdateData({
        endPoint: `/people/updateuser/${userInfo.clientId}/${editUserData.people_id}`,
        method: "PATCH",
        obj: {
          first_name: values.firstName,
          last_name: values.lastName,
          email: values.email,
          bio: values.bio || "",
          user_name: values.userName,
          password: values.password,
          country: "",
          grade_code: "",
          grade: "",
          competency: "",
          service_line: "",
          departrment: "",
          time_zone: values.timezone || "",
          peopel_type: editUserData?.type || "Learner - Type",
          upload_profile: "",
          active: !!values.activate,
          deactivated_at: values.deactivate ? new Date().toISOString() : null,
          exclude_notification: !!values.notification,
          created_at: null,
        },
      });
      message.success("User updated successfully");
      navigate("/users");
    } catch (error) {
      console.error("Update user error:", error);
      message.error(
        error?.response?.data?.message || "Failed to update user"
      );
    } finally {
      setSaving(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const hanldeClickCancel = () => {
    navigate("/users");
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <UsersStyle>
        <div className="main_container_box">
          <div className="edit_title_section">
            <LeftOutlined onClick={handleBack} />{" "}
            <h1 className="user-menu-title">Edit user</h1>
          </div>

          <br></br>
          <div className="adduser-container">
            <div>
              <Form.Item valuePropName="fileList" getValueFromEvent={normFile}>
                <Upload
                  action="/upload.do"
                  listType="picture-card"
                  maxCount={1}
                  className="upload-img-box"
                  fileList={fileList}
                  onPreview={handlePreview}
                  onChange={handleChange}
                >
                  <button
                    style={{
                      border: 0,
                      background: "none",
                    }}
                    type="button"
                  >
                    <PlusOutlined />
                    <div
                      style={{
                        marginTop: 8,
                      }}
                    >
                      Upload
                    </div>
                  </button>
                </Upload>

                {previewImage && (
                  <Image
                    wrapperStyle={{
                      display: "none",
                    }}
                    preview={{
                      visible: previewOpen,
                      onVisibleChange: (visible) => setPreviewOpen(visible),
                      afterOpenChange: (visible) =>
                        !visible && setPreviewImage(""),
                    }}
                    src={previewImage}
                  />
                )}
              </Form.Item>
            </div>

            <div className="add_form_container_box">
              <Form
                layout="vertical"
                initialValues={{
                  remember: true,
                }}
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
              >
                <Form.Item
                  label="First name"
                  name="firstName"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your first name!",
                    },
                  ]}
                  className="form_input_label"
                >
                  <Input className="" />
                </Form.Item>

                <Form.Item
                  label="Last name"
                  name="lastName"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your last name!",
                    },
                  ]}
                  // className="form_input_fields"
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    {
                      required: true,
                      type: "email",
                      message: "Please enter your email!",
                    },
                  ]}
                  className=""
                >
                  <Input />
                </Form.Item>

                <Form.Item label="Bio" name="bio" className="">
                  <TextArea />
                </Form.Item>

                <Divider />

                <p className="form_devided_labels">Sign in credentials</p>

                <Form.Item
                  label="Username"
                  name="userName"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your user name!",
                    },
                  ]}
                  className=""
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Password"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your password!",
                    },
                  ]}
                  className=""
                >
                  <Input.Password />
                </Form.Item>

                <Divider />

                <p className="form_devided_labels">Location and language</p>

                <Form.Item
                  label="Timezone"
                  name="timezone"
                  className="search-input-field "
                >
                  <Input suffix={<SearchOutlined />} placeholder="Search" />
                </Form.Item>

                <Form.Item label="language" className="">
                  <Select>
                    <Select.Option value="demo">Demo</Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item label="User Type" className="">
                  <Select>
                    <Select.Option value="demo">Demo</Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name="activate"
                  valuePropName=""
                  className="checkbox_form"
                >
                  <Checkbox>Activate</Checkbox>
                </Form.Item>
                <Form.Item
                  name="deactivate"
                  valuePropName=""
                  className="checkbox_form"
                >
                  <Checkbox>Deactivate</Checkbox>
                </Form.Item>
                <Form.Item
                  name="notification"
                  valuePropName=""
                  className="checkbox_form"
                >
                  <Checkbox>
                    Exclude from all non-essential emails and notifications
                  </Checkbox>
                </Form.Item>

                <Row className="form_button_section">
                  <div>
                    <Button type="primary" htmlType="submit" loading={saving}>
                      Save
                    </Button>
                  </div>

                  <div>
                    <Button type="" htmlType="" onClick={hanldeClickCancel}>
                      Cancel
                    </Button>
                  </div>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </UsersStyle>
    </>
  );
};

export default EditUser;
